export enum UserRoles {
  ADMIN = 'Admin',
  USER = 'User',
  QA = 'QA',
  MODERATOR = 'Moderator',
}
